import * as z from "zod/v4";

const trackingEventSchema = z.object({
  id: z.string(),
  timestamp: z.coerce.date(),
  status: z.string(),
  statusDetail: z.string().nullish(),
  message: z.string(),
  locationCity: z.string().nullish(),
  locationState: z.string().nullish(),
  locationCountry: z.string().nullish(),
  locationPostalCode: z.string().nullish(),
});

const shipmentDetailSchema = z.object({
  id: z.string(),
  trackingCode: z.string().nullish(),
  trackingUrl: z.string().nullish(),
  trackingProvider: z.string().nullish(),
  carrier: z.string().nullish(),
  carrierService: z.string().nullish(),
  unmappedCarrier: z.string().nullish(),
  status: z.string(),
  estimatedDeliveryAt: z.coerce.date().nullish(),
  lastTrackingUpdateAt: z.coerce.date().nullish(),
  preTransitAt: z.coerce.date().nullish(),
  inTransitAt: z.coerce.date().nullish(),
  outForDeliveryAt: z.coerce.date().nullish(),
  deliveredAt: z.coerce.date().nullish(),
  availableForPickupAt: z.coerce.date().nullish(),
  availableForPickupCarrierAt: z.coerce.date().nullish(),
  stalledInTransitAt: z.coerce.date().nullish(),
  returnToSenderAt: z.coerce.date().nullish(),
  deliveryAttemptedAt: z.coerce.date().nullish(),
  deliveryFailureAt: z.coerce.date().nullish(),
  shipmentCancelledAt: z.coerce.date().nullish(),
  shipmentErrorAt: z.coerce.date().nullish(),
  trackingEvents: z.array(trackingEventSchema),
});

export type ShipmentDetail = z.infer<typeof shipmentDetailSchema>;

export const getOrderTrackingShipmentDetail = {
  name: "getOrderTrackingShipmentDetail" as const,
  input: z.object({ shipmentId: z.string(), orderId: z.string().nullish() }),
  output: z.object({
    shipment: shipmentDetailSchema.nullable(),
    associatedShipments: z.array(shipmentDetailSchema),
  }),
};
